import React, { useEffect, useState } from 'react';

import { getIcon } from '../get-icon';
import type { NewCoreIconData } from '../types';

import { BaseIconDetails, type BaseIconDetailsProps } from './base-icon-details';

export type IconDetailsProps = BaseIconDetailsProps;
/**
 * __Icon details__
 *
 * A panel which is populated when an icon is selected.
 * Contains information about the icon. *
 */
export const IconDetails = ({
	icon,
	testId,
	isModal,
	onClose,
}: IconDetailsProps): React.JSX.Element => {
	const [replacementIcon, setReplacementIcon] = useState<NewCoreIconData>();

	useEffect(() => {
		if (icon?.replacement) {
			const iconPromise = getIcon(icon.replacement.location, icon.replacement.name);

			if (iconPromise) {
				iconPromise.then((icon) => {
					setReplacementIcon(icon);
				});
			}
		}
	}, [icon]);

	return (
		<BaseIconDetails
			icon={icon}
			testId={testId}
			isModal={isModal}
			onClose={onClose}
			replacementIcon={replacementIcon}
		/>
	);
};
